import React from "react";
import { useDispatch, useSelector } from "react-redux";
import UserAction from "../../../Actions/user";
import { UserApi } from "../../../Api/UserApi";
import Button from "../../../Atoms/Button/Button";
import ErrorMessage from "../../../Atoms/ErrorMessage";
import GlowingPicture from "../../../Atoms/GlowingPicture";
import useImageUpload from "../../../Hooks/useImageUpload";
import UserSelectors from "../../../Selectors/user";
import { useApi } from "../../../Utilities/Hooks/ApiHook";

export default function ProfilePicStage() {
  const profilePicture = useSelector(UserSelectors.profilePicture);
  const dispatch = useDispatch();

  const [dirty, setDirty] = React.useState(false);
  const [image, setImage] = React.useState(profilePicture);

  const { component, showImageUpload, imageRef } = useImageUpload(onImage);
  const { callApi, errorMessage, loading } = useApi(
    UserApi.uploadProfilePicture
  );

  function onImage(image) {
    setDirty(true);
    setImage(image);
  }

  function onUploadClick() {
    showImageUpload();
  }

  function onSave() {
    const imageElement = imageRef.current;
    if (!imageElement) {
      return;
    }

    const data = new FormData();
    data.append("image", imageElement.files[0]);

    callApi(data).then((response) => {
      setDirty(false);
      dispatch(UserAction.updateUser(response.data.data));
    });
  }

  return (
    <div>
      {image ? (
        <Picture image={image} onUploadClick={onUploadClick} />
      ) : (
        <EmptyPicture onUploadClick={onUploadClick} />
      )}

      <ErrorMessage>{errorMessage}</ErrorMessage>

      {dirty && (
        <div className="flex flex-row justify-end">
          <Button onClick={onSave} loading={loading}>
            Save
          </Button>
        </div>
      )}

      {component}
    </div>
  );
}

function Picture({ image, onUploadClick }) {
  return (
    <div className="flex flex-col items-center p-0 ">
      <GlowingPicture
        onClick={onUploadClick}
        imgUrl={image}
        width={250}
        height={250}
      />

      <p className="mt-5">Looks Good :)</p>
    </div>
  );
}

function EmptyPicture({ onUploadClick }) {
  return (
    <div className="flex flex-row items-center p-0 px-10">
      <div
        onClick={onUploadClick}
        className="p-5 w-20 h-20 bg-white rounded-full shadow-card-cream-sm flex justify-center items-center cursor-pointer"
      >
        <svg
          width="60"
          height="60"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1702_11433)">
            <path
              d="M26.4128 7.17294H23.2824L21.5541 4.56424C20.9019 3.58598 19.7606 2.99902 18.5867 2.99902H11.4128C10.2389 2.99902 9.09758 3.58598 8.44541 4.56424L6.71715 7.17294H3.58671C1.59758 7.17294 -0.000244141 8.77076 -0.000244141 10.7599V23.4121C-0.000244141 25.4012 1.59758 26.999 3.58671 26.999H26.4128C28.4019 26.999 29.9998 25.4012 29.9998 23.4121V10.7599C29.9998 8.77076 28.4019 7.17294 26.4128 7.17294ZM14.9998 24.0642C10.5324 24.0642 6.9128 20.4447 6.9128 15.9773C6.9128 11.5099 10.5324 7.92294 14.9998 7.92294C19.4671 7.92294 23.0867 11.5425 23.0867 16.0099C23.0867 20.4447 19.4671 24.0642 14.9998 24.0642ZM25.9563 12.2273C25.9237 12.2273 25.8911 12.2273 25.8258 12.2273H24.5215C23.9345 12.1947 23.478 11.7055 23.5106 11.1186C23.5432 10.5642 23.9671 10.1403 24.5215 10.1077H25.8258C26.4128 10.0751 26.9019 10.5316 26.9345 11.1186C26.9671 11.7055 26.5432 12.1947 25.9563 12.2273Z"
              fill="#F8B045"
            />
            <path
              d="M14.9998 11.5098C12.5215 11.5098 10.4998 13.5315 10.4998 16.0098C10.4998 18.488 12.5215 20.4772 14.9998 20.4772C17.478 20.4772 19.4998 18.4554 19.4998 15.9772C19.4998 13.4989 17.478 11.5098 14.9998 11.5098Z"
              fill="#F8B045"
            />
          </g>
          <defs>
            <clipPath id="clip0_1702_11433">
              <rect
                width="30"
                height="30"
                fill="white"
                transform="translate(-0.000244141 -0.000976562)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>

      <div className="mt-5 ml-5">
        <h3 className="text-sm">Upload your picture *</h3>
        <p className="text-sm text-gray-400 mt-3">
          Students have 70% higher chance of booking classes with teacher photos
        </p>
      </div>
    </div>
  );
}
